import React, { useContext, useState } from "react";
import { FilterContext } from "../../context/Filter";
import {
    fetchamcContTable,
    fetchamcExpiredContTable,
    fetchamcNonValidContTable,
    fetchamcValidContTable,
    fetchtotalChassisTable,
} from "./apiInsights";

import Amctotalchasistable from "./Amctotalchasistable";
import Amcvalid from "./Amcvalid";
import Amcconttable from "./Amcconttable";
import Amcexpiredtb from "./Amcexpiredtb";
import Amcnonvalidtable from "./Amcnonvalidtable";

const AmcTable = ({ data = [], loading }) => {
    const { superArn: parArn, childArn } = useContext(FilterContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);

    if (loading)
        return <p className="p-4 text-blue-500 font-medium">Loading...</p>;

    if (!data.length)
        return <p className="p-4 text-gray-500 font-medium">No data available</p>;

    const row = data[0];

    const openModal = (type) => {
        setModalType(type);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalType(null);
    };

    const renderModalContent = () => {
        switch (modalType) {
            case "total":
                return <Amctotalchasistable />;
            case "contract":
                return <Amcconttable />;
            case "valid":
                return <Amcvalid />;
            case "notvalid":
                return <Amcnonvalidtable />;
            case "expired":
                return <Amcexpiredtb />;
            default:
                return null;
        }
    };

    return (
        <div className="w-full bg-white rounded-xl shadow-md border border-gray-200 p-5">
            <div className="overflow-x-auto">
                <table className="min-w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-[#267CB8] text-white text-left">
                            <th className="px-4 py-2">Total No of Vehicles</th>
                            <th className="px-4 py-2">AMC Contract</th>
                            <th className="px-4 py-2">Valid</th>
                            <th className="px-4 py-2">Not Valid / Expired</th>
                            <th className="px-4 py-2">Expired Due to Period</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="text-center bg-blue-50 text-gray-800 font-medium">
                            {/* Total */}
                            <td
                                className="px-4 py-2 border-t border-gray-200 cursor-pointer text-blue-600 hover:underline"
                                onClick={() => openModal("total")}
                            >
                                {row.totalNoVehicle ?? 0}
                            </td>

                            {/* Contract */}
                            <td
                                className="px-4 py-2 border-t border-gray-200 cursor-pointer text-blue-600 hover:underline"
                                onClick={() => openModal("contract")}
                            >
                                {row.amc_contract ?? 0}
                            </td>

                            {/* Valid */}
                            <td
                                className="px-4 py-2 border-t border-gray-200 cursor-pointer text-blue-600 hover:underline"
                                onClick={() => openModal("valid")}
                            >
                                {row.amc_valid_count ?? 0}
                            </td>

                            {/* Not Valid / Expired */}
                            <td
                                className="px-4 py-2 border-t border-gray-200 cursor-pointer text-blue-600 hover:underline"
                                onClick={() => openModal("notvalid")}
                            >
                                {row.notValidExpired ?? 0}
                            </td>

                            {/* Expired Due to Period */}
                            <td
                                className="px-4 py-2 border-t border-gray-200 cursor-pointer text-blue-600 hover:underline"
                                onClick={() => openModal("expired")}
                            >
                                {row.expiredDueToPeriod ?? 0}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-5xl relative">
                        <button
                            onClick={closeModal}
                            className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-xl font-bold"
                        >
                            ✕
                        </button>
                        {renderModalContent()}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AmcTable;
